export default "__VITE_ASSET__C2HT97mW__"